module.exports = __webpack_public_path__ + "img/industry-banner-crm-02.f69027af.png";